import { ReactNode } from 'react';

import { type To } from 'react-router-dom';
import { GenericIconProps } from 'ui/components/icon/Icon';
import leapifyLogo from 'assets/images/Leapify-Logo-Dark.svg';
import HamburgerIcon from 'ui/components/icon/icons/HamburgerIcon';
import NavMenu from 'ui/components/nav/Menu/Menu';
import { cn } from 'utils/helpers';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

export type Route = {
  path: string;
  to?: string;
  label?: string;
  iconLeft?:
    | React.FC<GenericIconProps>
    | React.LazyExoticComponent<React.FC<GenericIconProps>>;
  element?: () => ReactNode;
  subMenu?: (Route & { childPath?: string })[];
  disabled?: boolean;
  atFooter?: boolean;
};

export type GlobalSidebarProps = {
  routes: Route[];
  isExpired?: boolean;
  defaultActive: string;
  defaultSubActive: string;
  onChange: (val: To) => void;
  collapse: boolean;
  toggleSidebar: () => void;
};

const GlobalSidebar: React.FC<GlobalSidebarProps> = ({
  routes,
  onChange,
  defaultActive,
  defaultSubActive,
  collapse,
  toggleSidebar,
}) => {
  return (
    <div
      className={cn(
        'flex-auto',
        'bg-fill-quarternary transition-all ease-out',
        'w-full',
        collapse && 'w-[58px]',
        !collapse && 'w-[230px]',
        'relative',
        'flex flex-col',
        'h-full',
      )}
    >
      <div className="py-[18px] px-4 flex items-center gap-4">
        <HamburgerIcon
          data-tut={TOUR_SELECTOR.TOUR.BURGER}
          role="button"
          className="w-6 h-6 cursor-pointer text-secondary-light"
          onClick={toggleSidebar}
        />
        {!collapse && (
          <button type="button">
            <img alt="Leapify Logo" className="w-[94px]" src={leapifyLogo} />
          </button>
        )}
      </div>
      <NavMenu
        className="relative flex-auto h-full"
        collapse={collapse}
        defaultActive={defaultActive}
        defaultSubActive={defaultSubActive}
        items={routes}
        onChange={onChange}
        subTriggerByClick
      />
    </div>
  );
};

export default GlobalSidebar;
